<template>
  <div class="col-3-center">
    <p>
      In der »Etappe II« wurden aus Stadtrat, Verwaltung und unterschiedlichen
      Interessensverbänden eine Arbeitsgruppe zur Erarbeitung der Leitgedanken
      des Leitbildes gebildet.
    </p>
    <!-- <p>
      Am 30.04.2019 und am 22.05.2019 hatten die vom Bau- und
      Planungsausschuss ausgewählten Mitglieder der Arbeitsgruppen im Rahmen
      eines Workshops die Gelegenheit, ihre Ideen zur Gestaltung ihres Lebensumfeldes einzubringen. Auf vorbereiteten Profiltischen konnten sie die Wünsche
      und Vorstellungen zu insgesamt neun Themen als Bildcollagen gestalten.
      Anhand der Zusammenfassung der acht Profilwerkstätten und den Beschreibungen der acht Stadtprofile wurden im nächsten Schritt erste Leitbilder entworfen.
      Einige der Anregungen wurden mehrfach bei verschiedenen Themenfeldern
      geäußert, was umso mehr ihre Bedeutung unterstreicht.
    </p>
    <p>
      Diese Leitgedanken werden durch den geplanten Bürgerworkshop der
      gesamten Stadtgesellschaft vorgestellt und im Diskurs weiterentwickelt.
      Vorab findet bis zum Bürgerworkshop noch eine Online-Beteiligung über
      die Projektinternetseite »www.dachaudenktweiter.de« statt. Nach der
      Zusammenfassung aller Anregungen werden die bisherigen Ergebnisse als
      Grundlage für einen Entwurf des Leitbildes herangezogen und auch räumliche
      Bezüge hergestellt.
    </p>-->
    <p>
      Die Dokumentation zum Download als PDF finden Sie
      <router-link to="/projekt/downloads">hier</router-link>.
    </p>
    <img :src="require('@/assets/fotos/arbeitsgruppe/arbeitsgruppe.png')" alt="arbeitsgruppe" />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Arbeitsgruppe"
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>